import { CartQuery, CartCreateMutation, GetToken } from '@water-web/api';
import { HttpPlatform } from '@water-web/types';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const CartServiceConstructor = (config: { baseUrl: string; platform: HttpPlatform; getToken: GetToken }) => ({
  get: new CartQuery(config.baseUrl),
  create: new CartCreateMutation(config),
});
